import { CommonModule, DatePipe } from "@angular/common";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { LoggerModule, NgxLoggerLevel } from "ngx-logger";
import { environment } from "src/environments/environment";
import { LoggerConfigurationService } from "./logger-configuration.service";
import { LoggingEffects } from "./state/logging-state/logging.effects";
import {
  loggingFeatureKey,
  loggingReducer,
} from "./state/logging-state/logging.reducer";

@NgModule({
  declarations: [],
  exports: [LoggerModule],
  imports: [
    CommonModule,
    LoggerModule.forRoot({
      level: environment.defaultLogLevel,
      serverLogLevel: NgxLoggerLevel.OFF,
      // TODO: Source maps don't work right; have open issue: https://github.com/dbfannin/ngx-logger/issues/167
      enableSourceMaps: environment.enableLoggingSourceMap,
      timestampFormat: "mediumTime",
    }),
    StoreModule.forFeature(loggingFeatureKey, loggingReducer),
    EffectsModule.forFeature([LoggingEffects]),
  ],
  providers: [
    DatePipe,
    LoggerConfigurationService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class LoggingModule {}
